import { useEffect, useState } from "react";
import { Button, Spin } from "antd";

// PDFs are stored in S3 as binary/octet-stream, so a frame pointed straight at them downloads them
// (or opens a new tab). The viewer reads the file (the bucket allows cross-site reads), labels it a
// PDF and shows it in the browser's own PDF viewer (pages, zoom, search, print) inside the modal.

export const isPdf = (attachment) => {
  if (!attachment) return false;
  const mime = (attachment.mime_type || "").toLowerCase();
  const name = (attachment.file_slug || attachment.file_name || attachment.direct_url || "").toLowerCase();
  return mime === "application/pdf" || name.split("?")[0].endsWith(".pdf");
};

const PdfViewer = ({ url, title, height = "70vh" }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    let created = null;
    setBlobUrl(null);
    setError(false);
    fetch(url, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.arrayBuffer();
      })
      .then((data) => {
        created = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
        setBlobUrl(created);
      })
      .catch((e) => {
        if (e.name !== "AbortError") setError(true);
      });
    return () => {
      controller.abort();
      if (created) URL.revokeObjectURL(created);
    };
  }, [url]);

  if (error) {
    return (
      <div className="pdf-viewer-error" style={{ padding: "24px 0" }}>
        <p>This PDF could not be shown here.</p>
        <Button href={url} target="_blank" rel="noopener noreferrer">Open the PDF</Button>
      </div>
    );
  }
  if (!blobUrl) {
    return (
      <div style={{ padding: "48px 0" }}>
        <Spin />
      </div>
    );
  }
  return (
    <div className="pdf-viewer">
      <div style={{ textAlign: "right", marginBottom: "6px" }}>
        <a href={blobUrl} target="_blank" rel="noopener noreferrer">Open in a new tab ↗</a>
      </div>
      <iframe
        className="pdf-viewer-frame"
        src={blobUrl}
        title={title || "PDF"}
        style={{ width: "100%", height, border: "1px solid #eee", borderRadius: "4px" }}
      />
    </div>
  );
};

export default PdfViewer;
